"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeTooltipWidget = exports.DefaultOffset = void 0;
var React = require("react");
var ChromeTooltipArrow_1 = require("./ChromeTooltipArrow");
var ChromeTooltipBox_1 = require("./ChromeTooltipBox");
var ChromeTooltipDisplay_1 = require("./ChromeTooltipDisplay");
var ChromeTooltipUtility_1 = require("./ChromeTooltipUtility");
// extra space for mousing between target and tooltip
var MouseSpace = 1;
exports.DefaultOffset = ChromeTooltipBox_1.BorderWidth + ChromeTooltipBox_1.Padding + ChromeTooltipArrow_1.Height / 2;
var DefaultSide = 'Right';
var Style = {
    position: 'relative',
    display: 'inline-block'
};
var ChromeTooltipWidget = /** @class */ (function (_super) {
    __extends(ChromeTooltipWidget, _super);
    function ChromeTooltipWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.targetElement = null;
        _this.tooltipElement = null;
        _this.canceled = false;
        _this.setContent = function (content) {
            if (!_this.canceled) {
                _this.setState(function (prevState) { return prevState.content ? prevState : __assign(__assign({}, prevState), { content: content }); });
            }
        };
        _this.open = function () {
            // tslint:disable-next-line:no-floating-promises
            _this.props.getContent().then(_this.setContent);
        };
        _this.close = function () {
            _this.setState({ content: null, positioned: false });
        };
        _this.handleClick = function (e) {
            _this.state.content ? _this.close() : _this.open();
            e.preventDefault();
        };
        _this.handleMouseEnter = function (e) {
            if (!_this.state.content) {
                _this.canceled = false;
                _this.open();
            }
        };
        _this.handleMouseLeave = function (_a) {
            var clientX = _a.clientX, clientY = _a.clientY;
            if (!_this.state.content) {
                // TFSID 740766: cancel if mouse outside target before finished fetching content
                _this.canceled = true;
            }
            if (_this.tooltipElement) {
                var _b = _this.tooltipElement.getBoundingClientRect(), left = _b.left, right = _b.right, top_1 = _b.top, bottom = _b.bottom;
                // add offset based on side
                switch (_this.state.side) {
                    case 'Top':
                        bottom += MouseSpace;
                        break;
                    case 'Bottom':
                        top_1 -= MouseSpace;
                        break;
                    case 'Left':
                        right += MouseSpace;
                        break;
                    case 'Right':
                        left -= MouseSpace;
                        break;
                    default:
                        ChromeTooltipUtility_1.assertNever(_this.state.side);
                }
                // close if mouse outside of tooltip
                var rectangle = new ChromeTooltipUtility_1.ClosedRectangle(left, right, top_1, bottom);
                if (!rectangle.containsPoint(clientX, clientY)) {
                    _this.close();
                }
            }
        };
        _this.updateTargetRef = function (element) {
            _this.targetElement = element;
        };
        _this.updateTooltipRef = function (element) {
            _this.tooltipElement = element;
        };
        _this.state = {
            content: null,
            positioned: false,
            side: props.defaultSide || DefaultSide,
            offset: exports.DefaultOffset
        };
        return _this;
    }
    ChromeTooltipWidget.prototype.componentDidUpdate = function () {
        if (this.state.content && !this.state.positioned) {
            if (!this.targetElement || !this.tooltipElement) {
                throw new Error('reference to target or tooltip isn\'t set!');
            }
            var outerRect = (this.props.boundaryElement || document.body).getBoundingClientRect();
            var innerRect = this.targetElement.getBoundingClientRect();
            // try to position tooltip within outer rectangle
            var _a = this.tooltipElement.getBoundingClientRect(), width = _a.width, height = _a.height;
            // try default side first
            var side = this.props.defaultSide || DefaultSide;
            var offset = this.state.offset;
            var i = 0;
            // tslint:disable-next-line: deprecation
            var rect = ChromeTooltipWidget.computeTooltipRectangle(innerRect, width, height, side, offset);
            while (i < ChromeTooltipUtility_1.NumberOfSides && !ChromeTooltipUtility_1.containsClientRect(outerRect, rect)) {
                i++;
                side = ChromeTooltipUtility_1.getNextSideClockwise(side);
                // tslint:disable-next-line: deprecation
                rect = ChromeTooltipWidget.computeTooltipRectangle(innerRect, width, height, side, offset);
            }
            this.setState({ positioned: true, side: side });
        }
    };
    ChromeTooltipWidget.prototype.componentDidMount = function () {
        this.canceled = false;
    };
    // NOTE cancel any unresolved promise of content to avoid setting state on unmounted component,
    // see https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html for more information
    ChromeTooltipWidget.prototype.componentWillUnmount = function () {
        this.canceled = true;
    };
    ChromeTooltipWidget.prototype.render = function () {
        return (React.createElement("div", { onClick: this.handleClick, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, ref: this.updateTargetRef, style: Style },
            this.props.children,
            this.renderTooltip()));
    };
    ChromeTooltipWidget.prototype.renderTooltip = function () {
        if (this.state.content && this.targetElement) {
            return React.createElement(ChromeTooltipDisplay_1.ChromeTooltipDisplay, { content: this.state.content, width: this.props.width, targetElement: this.targetElement, handleRef: this.updateTooltipRef, close: this.close, positioned: this.state.positioned, side: this.state.side, offset: this.state.offset, zIndex: this.props.zIndex });
        }
        else {
            return null;
        }
    };
    // tslint:disable-next-line:max-line-length
    ChromeTooltipWidget.computeTooltipRectangle = function (target, width, height, side, offset) {
        var top;
        var left;
        if (ChromeTooltipUtility_1.isHorizontalSide(side)) {
            top = target.top + target.height / 2 - offset;
            left = side === 'Left' ? target.left - width : target.right;
        }
        else {
            left = target.left + target.width / 2 - offset;
            top = side === 'Top' ? target.top - height : target.bottom;
        }
        return {
            top: top,
            bottom: top + height,
            left: left,
            right: left + width,
            width: width,
            height: height
        };
    };
    return ChromeTooltipWidget;
}(React.Component));
exports.ChromeTooltipWidget = ChromeTooltipWidget;
//# sourceMappingURL=ChromeTooltipWidget.js.map